var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from "vue-property-decorator";
import Tooltip from "../tooltip.vue";
var PlanComparisonCell = /** @class */ (function (_super) {
    __extends(PlanComparisonCell, _super);
    function PlanComparisonCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.IS_TICK_REGEX = /^[yn]$/i;
        // FYI: This is a pretty meh regex:
        _this.BUTTON_REGEX = /^\s*\[([a-z\-_]+)(?:\s+([a-z\-_]+)="?([^"]+)"?)*\]\s*$/i;
        _this.isTick = false;
        _this.isButton = false;
        _this.button = [];
        return _this;
    }
    PlanComparisonCell.prototype.created = function () {
        this.isTick = !!this.value.match(this.IS_TICK_REGEX);
        this.button = this.value.match(this.BUTTON_REGEX);
        this.isButton = !!this.button;
    };
    __decorate([
        Prop({ default: '', type: String })
    ], PlanComparisonCell.prototype, "label", void 0);
    __decorate([
        Prop({ default: '', type: String })
    ], PlanComparisonCell.prototype, "value", void 0);
    __decorate([
        Prop({ default: '', type: String })
    ], PlanComparisonCell.prototype, "mobileTooltip", void 0);
    __decorate([
        Prop({ default: false, type: Boolean })
    ], PlanComparisonCell.prototype, "isPrice", void 0);
    __decorate([
        Prop({ default: false, type: Boolean })
    ], PlanComparisonCell.prototype, "isVisibleOnMobile", void 0);
    __decorate([
        Prop({ default: '', type: String })
    ], PlanComparisonCell.prototype, "confirmedTechnology", void 0);
    PlanComparisonCell = __decorate([
        Component({
            components: { Tooltip: Tooltip }
        })
    ], PlanComparisonCell);
    return PlanComparisonCell;
}(Vue));
export default PlanComparisonCell;
